import "./homepage.css";
import Header from "../components/header";
import StandOutText from "../components/standout-text";
import MediaAndText from "../components/media-and-text";
import PricingHolder from "../components/pricing-holder";
import HomePageVideo from "../components/homepage-video";
import ValueStrip from "../components/value-strip";
import HowItWorks from "../components/how-it-works";
import HomepageHero from "../components/homepage-hero";
import StatsStrip from "../components/stats-strip";
import LinkedinFeature from "../components/linkedin-feature";

// Optional: tweak these paths to match your actual screenshots
const INPUT_IMG = "./images/product-screenshots/new-inputs.png";
const FEED_IMG = "./images/product-screenshots/new-feed.png";
const ALERT_IMG = "./images/product-screenshots/new-alerts.png";
const INSIGHTS_IMG = "./images/product-screenshots/new-insights.png";
const CREATE_IMG = "./images/product-screenshots/new-create.png";
const IDEA_IMG = "./images/product-screenshots/new-ideas.png";
const VOICES_IMG = "./images/product-screenshots/new-voice.png";
const CALENDAR_IMG = "./images/product-screenshots/new-schedule.png";

function HomePage() {
  const navigateToSignup = () => {
    window.location.href = "/signup";
  };

  const navigateToLogin = () => {
    window.location.href = "/login";
  };

  return (
    <>
      <Header
        hideIcons={true}
        CTA="Sign up"
        functionForButton={navigateToSignup}
        CTA2="Log in"
        functionForButton2={navigateToLogin}
        displayAdditionalNavComponents={true}
      />

      <main className="homepage">
        {/* HERO */}
        <HomepageHero />

        <StatsStrip />

        {/*<HomePageVideo />*/}

        {/* POSITIONING / SOCIAL PROOF */}
        <section className="positioning-strip">
          <StandOutText />
        </section>

        {/* VALUE STRIP */}
        <ValueStrip />

        {/* PRODUCT SECTIONS USING YOUR EXISTING COMPONENTS */}

        <MediaAndText
          heading="Tell it what to read. It never stops watching."
          text="Add a domain (competitor.com, media site or your own) as an ‘input’. Mako continuously monitors them for new pages, launches and announcements so you don't have to remember to check."
          image={INPUT_IMG}
        />

        <MediaAndText
          heading="One feed. Everything your inputs publish."
          text="See every new post, launch and thought piece from your inputs in a single stream. The internet, read and organised for you - no more ten open tabs."
          image={FEED_IMG}
          reversed={true}
        />

        <MediaAndText
          heading="Alerts when something's worth your voice"
          text="The agent flags what matters: a competitor's new feature, a breakout idea from a thought leader. You get the nudge to respond while it's still fresh - and sound like you know the space."
          image={ALERT_IMG}
        />

        <MediaAndText
          heading="Insights: what's shifting, surfaced for you"
          text="Mako clusters related posts, spots themes and surfaces angles in your space. You get a digest of what's changing and how to talk about it - without reading every article yourself."
          image={INSIGHTS_IMG}
          reversed={true}
        />

        <MediaAndText
          heading="See what's moving before everyone else piles on"
          text="Your feed and Insights highlight what's changing in your space — competitors, narratives, launches — so you can decide where to lean in and speak with authority when you're ready."
          image={IDEA_IMG}
        />

        <MediaAndText
          heading="Voices, calendar, LinkedIn — organised in one place"
          text="Run multiple profiles with clear personas, see who's publishing when, and keep a steady rhythm — without juggling spreadsheets or losing track of who said what."
          image={CREATE_IMG}
          reversed={true}
        />

        <MediaAndText
          heading="Multiple voices, one authentic thread"
          text="Company page, founder, team: create up to 10 voices, each with its own persona. The agent keeps every post consistent and authoritative so each account sounds like the person behind it."
          image={VOICES_IMG}
        />

        <MediaAndText
          heading="Schedule your presence. Stay in the conversation."
          text="One calendar for all your voices. See who's posting when, keep a steady rhythm of insight-led content, and never leave your audience with radio silence."
          image={CALENDAR_IMG}
          reversed={true}
        />

        <LinkedinFeature />

        {/* PRICING */}
        <section className="pricing-section">
          <PricingHolder />
        </section>
      </main>
    </>
  );
}

export default HomePage;
